import { Plugin } from "vue";

const envPlugin: Plugin = {
  install: (app) => {
    app.config.globalProperties.$env = process.env;
  },
};

export { envPlugin };
